export const endpoint = {
	auth: {
		LOGIN: '/api/auth/token',
	},
	gpsr: {
		GET_FILE: (productTypeId: string) => `/api/file/${productTypeId}`,
		GET_PRODUCT_TYPE: (productTypeId: string) => `/api/gpsr/${productTypeId}`,
		GET_SKU: (productTypeId: string) => `/api/gpsr/${productTypeId}/sku`,
	},
};
